module.exports = __webpack_public_path__ + "740555a56183919daa61aade91a4397b.svg";